<template>
  <div class="container-fluid overflow-auto">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button class="mr-2" variant="success" @click="exportBusinessEquityV2()">匯出每期業務權益2.0總表</b-button>
      </template>
    </bread-crumb>

    <b-input-group prepend="期別" class="mb-4">
      <b-form-input
        placeholder="請輸入期別(EX：11005)"
        v-model.number="search.period"
        @keyup.enter="getSales(1)" />

      <b-input-group-append>
        <b-button size="sm" text="Button" variant="success" @click="getSales(1)">搜尋</b-button>
      </b-input-group-append>
    </b-input-group>

    <!-- <b-tabs v-model="tab.tabIndex" class="mb-4">
      <b-tab
        v-for="(item, index) in tab.items"
        :key="index"
        :title="item.label" />
    </b-tabs> -->

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getSales"
      tableId="businessEquityV2"
    >
      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

      <template #cell(status)="row">
        <span v-if="row.item.status === 0">正常</span>
        <span v-else-if="row.item.status === 1">失效</span>
        <span v-else-if="row.item.status === 2">停權</span>
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(new_member_join_date)="row">
        {{ convertRocDate(row.item.new_member_join_date) }}
      </template>
    </tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import businessApi from "@/models/API/businessApi";
import { countNoNum, convertRocDate, getRocYearAndMonthOfPeriod, downloadFile } from "@/models/HELPERS/common.js";


export default {
  name: 'businessEquityV2',
  components: {
    BreadCrumb,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '業務管理', url: '', isActive: true },
          { name: '每期業務權益2.0總表', url: '', isActive: false }
        ]
      },
      search: {
        period: '',
        status: '',
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "no",
            label: "No"
          },
          {
            key: "number",
            label: "業務編號",
            sortable: true
          },
          {
            key: "name",
            label: "業務姓名",
            sortable: true
          },
          {
            key: "cellphone",
            label: "手機",
            sortable: true
          },
          {
            key: "rank",
            label: "目前聘階",
            sortable: true
          },
          {
            key: "status",
            label: "權益",
            sortable: true
          },
          {
            key: "join_date",
            label: "報聘日期",
            sortable: true
          },
          {
            key: "new_member_number",
            label: "最新報件契約編號"
          },
          {
            key: "new_member_name",
            label: "最新報件要助人"
          },
          {
            key: "new_member_join_date",
            label: "最新報件日"
          },
          {
            key: "remark",
            label: "註記"
          }
        ],
        page: {},
        table_sort: {
          sortBy: '',
          sort: ''
        },
        temp_table_data: {},
      },
      tab: {
        items: [
          { value: '', label: '全部' },
          { value: 0, label: '正常' },
          { value: 1, label: '失效' },
          { value: 2, label: '停權' },
        ],
        tabIndex: 0
      }
    }
  },
  watch: {
    'tab.tabIndex': {
      handler(newValue, oldValue) {
        this.search.status = this.tab.items[newValue].value;

        this.getSales();
      },
      immediate: false
    }
  },
  mounted() {
    this.businessApi = new businessApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.businessApi.page);

      this.search.period = getRocYearAndMonthOfPeriod();
      this.getSales();
    },
    countNoNum,
    convertRocDate,
    // 查詢業務
    getSales(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      // 檢查是否輸入5位數
      const regex = /^\d{5}$/;
      const is_valid = regex.test(this.search.period);

      if (!is_valid) {
        const result = { message: `期別格式輸入錯誤(EX：11005)`, title: '每期業務權益2.0總表' };

        this.businessApi.toast(() => {}, result, false);

        return;
      }

      const params = {
        ...this.search,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort
      };
      this.businessApi.getSales((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數

        this.data.table_data = res.data;
      }, params)
    },
    // 匯出每期業務權益2.0總表EXCEL
    exportBusinessEquityV2() {
      if (!this.search.period) {
        const result = { message: '請輸入期別!!', title: '每期業務權益2.0總表' };
        this.businessApi.toast(() => {}, result, false);

        return;
      }

      this.businessApi.exportSales((response) => {
        if (!response) return;

        downloadFile(response);
      }, this.search)
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/businessEquityV2.vue